// extracted by css-extract-rspack-plugin
export default {"TabsListSidebar":"G28Lr"};